import useApp from "./useApp";
import { useCoordinates } from "./useCoordinates";
import useData from "./useData";
import { useMinifiedMenu } from "./useMinifiedMenu";
import { usePins } from "./usePins";
import useScreen from "./useScreen";
import useSignalR from "./useSignalR";
import useUnity from "./UseUnity";

const allHooks = {
  useApp,
  useData,
  useScreen,
  useSignalR,
  useCoordinates,
  useUnity,
  usePins,
  useMinifiedMenu
};

export default allHooks;